var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"d-center"},[_c('div',{staticClass:"p-1 progress-icon border-primary",class:{
        'active-tracking': _vm.statusIndexCondition
          ? _vm.status >= _vm.statusIndexCondition && _vm.status != 10
          : _vm.condition,
      }},[_c('FeatherIcon',{attrs:{"size":"30","icon":_vm.icon}})],1)]),_c('h6',[_vm._v(_vm._s(_vm.label))]),_c('h5',[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }